import React, { createContext, useContext, useMemo } from 'react';

const EditorContext = createContext(null);

export function EditorProvider({
  children,
  fabricRef,
  originalRef,
  viewportRef,
  ready,
  bgColor,
  setBgColor,
  activeTool,
  setActiveTool,
  selection,
  setSelection,
  layersOpen,
  setLayersOpen,
  zoomPercent,
  setZoomPercent,
  stickerCategories,
  refreshLayers,
  currentTemplateId,
}) {
  const value = useMemo(
    () => ({
      fabricRef,
      originalRef,
      viewportRef,
      ready,
      bgColor,
      setBgColor,
      activeTool,
      setActiveTool,
      selection,
      setSelection,
      layersOpen,
      setLayersOpen,
      zoomPercent,
      setZoomPercent,
      stickerCategories,
      refreshLayers,
      currentTemplateId,
    }),
    [
      fabricRef,
      originalRef,
      viewportRef,
      ready,
      bgColor,
      setBgColor,
      activeTool,
      setActiveTool,
      selection,
      setSelection,
      layersOpen,
      setLayersOpen,
      zoomPercent,
      setZoomPercent,
      stickerCategories,
      refreshLayers,
      currentTemplateId,
    ]
  );

  return <EditorContext.Provider value={value}>{children}</EditorContext.Provider>;
}

export function useEditor() {
  const ctx = useContext(EditorContext);
  if (!ctx) throw new Error('useEditor must be used within EditorProvider');
  return ctx;
}

export function useFabricCanvas() {
  const { fabricRef } = useEditor();
  return fabricRef.current;
}
